export const web = {
  primary: "#38587E",
  secondary: "#FFFFFF",
};

export const mobile = {
  primary: "#FFC960",
  secondary: "#373E4D",
};
